var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-mixin"},[_vm._v(" "+_vm._s(_vm.projectNames)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }